import { Component, Input } from '@angular/core';

@Component({
  selector: 'p-percentage-label',
  templateUrl: './p-percentage-label.component.html',
  styleUrls: ['./p-percentage-label.component.scss'],
})
export class PPercentageLabelComponent {
  @Input() percentage!: number;
}
